// A job is expired when its visibility deadline (expires_at, else start_date) is in the past,
// unless the owner explicitly kept it open. Closed/in-progress jobs are handled by status.
export const isJobExpired = (job) => {
  if (!job) return false;
  if (job.status === 'expired') return true;
  if (job.status === 'closed' || job.status === 'in_progress') return false;
  const ref = job.expires_at || job.start_date;
  if (!ref) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return new Date(ref) < today;
};

export const jobStatusLabel = (job) => {
  if (job.status === 'in_progress') return { label: 'En cours', className: 'bg-amber-100 text-amber-700 border border-amber-300' };
  if (job.status === 'closed') return { label: 'Fermé', className: 'bg-gray-100 text-gray-700' };
  if (isJobExpired(job)) return { label: 'Expiré', className: 'bg-red-100 text-red-700 border border-red-300' };
  return { label: 'Ouvert', className: 'bg-emerald-100 text-emerald-700' };
};

export const EXPIRED_TITLE = 'Chantier expiré';
export const EXPIRED_DESCRIPTION = "Cette annonce n'a pas été renouvelée par son auteur. Elle n'est plus ouverte aux candidatures.";

// Public listings mask expired jobs unless the viewer owns them
export const displayJob = (job, viewer) => {
  const owner = viewer && (job.company_id === viewer.id || viewer.role === 'admin');
  if (!isJobExpired(job) || owner) return { ...job, masked: false };
  return { ...job, masked: true, title: EXPIRED_TITLE, description: EXPIRED_DESCRIPTION, budget_min: null, budget_max: null, is_urgent: false };
};

export const addDays = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};
